import { Component, OnInit } from '@angular/core'
import { ContentfulDfdsService } from '../resources/contentful-dfds.service'
import injectChatScript from './chat.script'
import { LoggingService } from '../logging.service'
import { LocaleService } from '../locale-service'

@Component({
    selector: 'sbw-chat',
    template: '<div></div>',
})

export class ChatComponent implements OnInit {

    constructor(
        private contentfulDfdsService: ContentfulDfdsService,
        private logService: LoggingService,
        private localeService: LocaleService) { }

    async ngOnInit() {
        try {
            let entry = await this.contentfulDfdsService.getLiveChatById('4MNHT9wEnaLlb5fVPiXaum')
            if (entry && entry.fields && entry.fields.showLiveChatOnSeabookBooking) {
                injectChatScript(entry.fields)
            }
        }
        catch {
            this.logService.logWarn({
                message: 'Live chat not working on Locale: {Locale}',
                params: [this.localeService.getLocale()]
            })
        }
    }
}

